module.exports = __webpack_public_path__ + "img/sample-diversification2.cfc8aa65.png";